module.exports = __webpack_public_path__ + "media/components/SaveMoneyMakeMoney/make-money-background-d45293dae9aa5d855ee6bb8cf7ba1dc6.png";